/**
 * Generated by orval v7.20.0 🍺
 * Do not edit manually.
 * MALIYONE-LOAN-MANAGEMENT-API API
 * API specification for MALIYONE-LOAN-MANAGEMENT-API
 * OpenAPI spec version: 1.0.0
 */

export type MaritalStatus = typeof MaritalStatus[keyof typeof MaritalStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MaritalStatus = {
  UNKNOWN: 'UNKNOWN',
  MARRIED_UNKNOWN: 'MARRIED_UNKNOWN',
  SINGLE: 'SINGLE',
  IN_COMMUNITY_OF_PROPERTY: 'IN_COMMUNITY_OF_PROPERTY',
  OUT_OF_COMMUNITY_OF_PROPERTY: 'OUT_OF_COMMUNITY_OF_PROPERTY',
  TRADITIONAL_CUSTOMARY: 'TRADITIONAL_CUSTOMARY',
  DIVORCED: 'DIVORCED',
  WIDOWED: 'WIDOWED',
} as const;
